import React from 'react';

import { signInWithPopup, signOut } from 'firebase/auth';
import toast from 'react-hot-toast';
import { MdOutlineArrowBack } from 'react-icons/md';
import { useHistory } from 'react-router-dom';

import {
  auth,
  googleAuthProvider,
  facebookAuthProvider,
} from 'services/firebase';

import logoImg from '../../assets/logo.png';
import {
  Container,
  Content,
  AnimationContainer,
  SignInOptionButton,
  Background,
  ReturnLink,
} from './styles';

const SignIn: React.FC = () => {
  const history = useHistory();

  const signInWithGoogle = async (): Promise<void> => {
    try {
      await signInWithPopup(auth, googleAuthProvider);
      history.goBack();
    } catch {
      toast.error(
        'Ocorreu um erro inesperado ao fazer o login. Tente novamente',
      );
      await signOut(auth);
    }
  };

  const signInWithFacebook = async (): Promise<void> => {
    await signInWithPopup(auth, facebookAuthProvider);
    history.goBack();
  };

  return (
    <Container>
      <Content>
        <AnimationContainer>
          <img src={logoImg} alt="Circle" />
          <br />
          <p>Escolha uma das opções de login:</p>
          <br />
          <br />
          <SignInOptionButton type="button" onClick={signInWithGoogle}>
            <img src="/google.png" alt="Google" /> Entrar com Google
          </SignInOptionButton>
          <SignInOptionButton type="button" onClick={signInWithFacebook}>
            <img src="/facebook.png" alt="Facebook" /> Entrar com Facebook
          </SignInOptionButton>
          <ReturnLink to="/">
            <MdOutlineArrowBack color="#000" />
            <p>Voltar para a página principal</p>
          </ReturnLink>
        </AnimationContainer>
      </Content>

      <Background />
    </Container>
  );
};

export default SignIn;
